export const configData =  {  

    APP_URL: "/basic/web/api/",
    DOMAIN_URL: "https://preteamsmww.preferati.net/basic/web/",
    DRUPAL_APP_URL: "https://betasmww.preferati.net/api/",
    DRUPAL_DOMAIN_URL: "https://betasmww.preferati.net",
    AGENCY_DOMAIN_URL: "https://betasmwwagency.preferati.net",
    SCOUT_DOMAIN_URL: "https://betasmwwscout.preferati.net",
    RSMWW_DOMAIN: "preteamsmww.preferati.net",
    RSMWW_AGENCY_DOMAIN: "presmwwagency.preferati.net",
	RSMWW_AGENCY_DOMAIN1: "presmwwagency.preferati.net",
    RSMWW_SCOUT_DOMAIN: "presmwwscout.preferati.net",
	RSMWW_SCOUT_DOMAIN1: "presmwwscout.preferati.net",
	RSMWW_SCOUT_DOMAIN2: "presmwwscout.preferati.net",
    RSMWW_AGENCY_URL: "https://presmwwagency.preferati.net",
    RSMWW_SCOUT_URL: "https://presmwwscout.preferati.net",
    RSMWW_URL: "https://preteamsmww.preferati.net",
    GOOGLE_RECAPTCHA_SITE_KEY: '6Ld4sRcsAAAAAExeVnOiq6zy_NtSheLSx4FiJRCI',
    //GOOGLE_RECAPTCHA_SITE_KEY: '6LeUZTYsAAAAAOl-sjYYG5jRdVv8MsvQ0rOajT_Q',
    DOMAIN_PUBLIC_URL: `${window.location.protocol}//${window.location.hostname}`,
    FB_PIXEDL_ID: '123456789',
    ROLE_ADMINISTRATOR: 3,
    ROLE_SAADMIN: 8,
    ROLE_SALES_PEOPLE:10,
    ROLE_SALES_DIRECTOR:18,
    ROLE_APPLICATION:12,
    ROLE_GLOBAL_AMBASSADOR:26,
    ROLE_AGENT:6,
    ROLE_SCOUT:5,
    ROLE_ATHLETE:11,
    ROLE_MENTOR:7,
    ROLE_AUTHENTICATED_USER:2
     }